import { H3, Stack } from "@adfenix/alexandria";
import NotSeeingTheRightPagesInfo from "./NotSeeingTheRightPagesInfo";
import { useTranslation } from "react-i18next";

const NoPage = () => {
  const { t } = useTranslation();
  return (
    <Stack spacing="l">
      <H3 style={{ marginBottom: 24 }}>{t("selfonboarding.noPage.header")}</H3>

      <NotSeeingTheRightPagesInfo />
    </Stack>
  );
};

export default NoPage;
